import type { Extension } from '@codemirror/state';
import { EditorView } from '@codemirror/view';
import CodeMirror from '@uiw/react-codemirror';
import { useModel } from '@umijs/max';
import React from 'react';

export interface CodeEditorProps {
  value: string;
  onChange?: (value: string) => void;
  /** 语法高亮等语言扩展，如 import { json } from '@codemirror/lang-json' */
  extensions?: Extension[];
  readOnly?: boolean;
  height?: string;
  minHeight?: string;
  maxHeight?: string;
  placeholder?: string;
}

/**
 * 通用代码/文本编辑器（CodeMirror 6）。
 * 行号、语法高亮、括号匹配、折行等开箱即用；主题跟随布局暗色模式。
 */
const CodeEditor: React.FC<CodeEditorProps> = ({
  value,
  onChange,
  extensions,
  readOnly,
  height,
  minHeight,
  maxHeight,
  placeholder,
}) => {
  const { initialState } = useModel('@@initialState');
  const isDark = initialState?.settings?.navTheme === 'realDark';

  return (
    <div style={{ border: '1px solid rgba(5, 5, 5, 0.08)', borderRadius: 6, overflow: 'hidden' }}>
      <CodeMirror
        value={value}
        height={height}
        minHeight={minHeight}
        maxHeight={maxHeight}
        theme={isDark ? 'dark' : 'light'}
        extensions={[EditorView.lineWrapping, ...(extensions ?? [])]}
        onChange={onChange}
        readOnly={readOnly}
        placeholder={placeholder}
        basicSetup={{
          foldGutter: true,
          autocompletion: false,
        }}
      />
    </div>
  );
};

export default CodeEditor;